import axios from "@/utils/request";
// 查询楼凤购买记录
export function queryCertificate(data) {
  return axios.post(`/user/certificate`, data);
}